module.exports = __webpack_public_path__ + "img/COMBO RADIO 2 PURPLE.9d352af.svg";